// import React from 'react';
class ScrollHandler {
  constructor() {
    this.callbacksArray = [];
    this.callbacksObj = {};
    this.registerCallback(window);
  }

  addCallback(callback) {
    if (this.callbacksArray.indexOf(callback) > -1) {
      return;
    }
    this.callbacksArray.push(callback);
  }

  removeCallback(callback) {
    const index = this.callbacksArray.indexOf(callback);
    if (index > -1) {
      this.callbacksArray.splice(index, 1);
    }
  }

  removeCallbackObj(ObjName) {
    delete this.callbacksObj[ObjName];
  }

  addCallbackObj(callback, ObjName) {
    /*    if (this.callbacksObj[ObjName]) {
      return;
    } */
    this.callbacksObj[ObjName] = callback;
  }

  registerCallback(windowObj) {
    let lastPosition = -1;
    const self = this;
    const windowScrollHandler = () => {
      requestAnimationFrame(() => {
        if (
          lastPosition === windowObj.pageYOffset
          || (self.callbacksArray.length === 0 && Object.keys(self.callbacksObj).length === 0)
        ) {
          windowScrollHandler();
          return false;
        }
        lastPosition = windowObj.pageYOffset;
        self.callbacksArray.map(callback => callback());

        for (const key in self.callbacksObj) {
          if (self.callbacksObj.hasOwnProperty(key)) {
            self.callbacksObj[key]();
          }
        }

        windowScrollHandler();
      });
    };
    windowScrollHandler();
  }
}

const WindowScrollHandler = new ScrollHandler();
export default WindowScrollHandler;
